import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=6dfb4893&scoped=true&"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordDialog.vue?vue&type=style&index=0&id=6dfb4893&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb4893",
  null
  
)

export default component.exports